import React from 'react'
export const PRIMARY_COLOR = "#ff5a5f";
export const SECONDARY_COLOR = "#61dafb";
